import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ApiCore } from 'src/app/config/api';
import { ApiService } from 'src/app/core/http/api.service';
import { IWallet } from 'src/app/components/my-credits/interfaces';
import { AuthService } from 'src/app/core/auth/auth.service';
import { EventMenuProfileService } from 'src/app/components/profile-menu/profile-menu.service';
import { MainLayoutComponent } from '../../main-layout.component';
import { myCreditsMobileService } from 'src/app/shared/services/myCredits-mobile.service';

@Component({
  selector: 'app-bottom-menu',
  templateUrl: './bottom-menu.component.html',
  styleUrls: ['./bottom-menu.component.css'],
})
export class BottomMenuComponent implements OnInit {
  public showSecondProfileMenu: boolean = false;
  public selectedOption: number = 0;
  public showGlobalMenu: boolean = false;
  public showBonus: boolean = false;
  public showProfileMenu: boolean = true;
  public titleMenu = '';
  public menuOptions: Record<number, string> = {
    1: 'Menú',
    2: 'Créditos',
    3: 'Cajero',
    4: 'Bonos',
    5: 'Perfil',
  };
  public showTransactions: boolean = false;

  private ignoreNextClick: boolean = false;
  @Input() wallet: IWallet = {
    bonus: 0,
    credits: 0,
    total: 0,
  };
  @Input() public newNotiBonos: boolean = false;
  @Input() public newNotiTransactions: boolean = false;
  @Input() public isPcPlayer: boolean = false;
  // @Output() onClose: EventEmitter<boolean> = new EventEmitter();

  @HostListener('window:resize')
  onResize() {
    const isMobile = window.innerWidth <= 768;
    if (!isMobile && this.showGlobalMenu) {
      this.closeGlobalMenu();
    }
  }

  public isLoggedIn: boolean = false;
  public showLoginModal: boolean = false;
  public showCreateAccountModal: boolean = false;
  @Input() social_networks: any = [];

  constructor(
    private readonly apiService: ApiService,
    private readonly router: Router,
    private readonly elementRef: ElementRef,
    private readonly auth: AuthService,
    private readonly eventMenuProfileService: EventMenuProfileService,
    private readonly appMain: MainLayoutComponent,
    private readonly myCreditsMobile: myCreditsMobileService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        setTimeout(() => {
          this.handleNavigation(event.url);
        }, 100);
      }
    });
    this.listenMenu();
    this.eventMenuProfileService.$eventCloseSesionFromOutsideMenu.subscribe(
      (e) => {
        this.isLoggedIn = false;
      }
    );
    this.eventMenuProfileService.$eventLogin.subscribe((e) => {
      this.isLoggedIn = true;
    });
  }

  private handleNavigation(url: string): void {
    this.showSecondProfileMenu = url.includes('/profile');
    this.showGlobalMenu = false;
    this.showProfileMenu = true;
  }

  private listenMenu() {
    this.eventMenuProfileService.$showProfile.subscribe((e) => {
      if (e) {
        this.showSecondProfileMenu = true;
      } else {
        this.showSecondProfileMenu = false;
      }
    });
  }

  ngOnInit(): void {
    this.auth.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
      if (status) {
        this.listenToCredits(); // te suscribes cuando el user ya está logueado
      }
    });
    this.handleNavigation(this.router.url);

    this.verifyLoggedIn();
    if (this.showGlobalMenu) {
      this.toggleBodyScroll(true);
    }
  }

  // Fix problems with scroll
  public toggleBodyScroll(disable: boolean): void {
    if (disable) {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      if (this.ignoreNextClick) {
        this.ignoreNextClick = false;
        return;
      }
      if (this.showGlobalMenu) {
        this.closeGlobalMenu();
      }
    }
  }

  toggleBonos() {
    if (!this.isLoggedIn) {
      console.log('showLoginModal');
      this.showLoginModal = true;
      return;
    }

    if (this.showBonus === false) {
      this.newNotiBonos = false;
      this.seenNotiBonos();
    }
    this.showBonus = !this.showBonus;
  }

  seenNotiBonos() {
    this.apiService
      .updateDirect(ApiCore.OPERATOR + '/update-bonuses-pendings', {})
      .subscribe({
        next: (res) => {
          console.log({ updateDirect: res });
          // idPlayer
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  toggleTransactions() {
    if (!this.isLoggedIn) {
      console.log('showLoginModal');
      this.showLoginModal = true;
      return;
    }

    if (this.showTransactions === false) {
      this.newNotiTransactions = false;
      this.seenNotiTransactions();
    }
    this.showTransactions = !this.showTransactions;
  }

  seenNotiTransactions() {
    this.apiService
      .updateDirect(ApiCore.OPERATOR + '/update-transactions-pendings', {})
      .subscribe({
        next: (res) => {
          console.log({ updateDirect: res });
          // idPlayer
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
  verifyLoggedIn() {
    this.isLoggedIn = this.auth.isAuthenticated();
  }

  changeLoginModalVisibility($event: boolean): void {
    this.showLoginModal = $event;
  }

  toggleProfile() {
    this.showSecondProfileMenu = !this.showSecondProfileMenu;
    this.showGlobalMenu = !this.showGlobalMenu;
    this.showProfileMenu = true;
  }

  //
  toggleGlobalMenu(val: number): void {
    if (!this.isLoggedIn && val !== 1) {
      this.showGlobalMenu = false;
      this.showLoginModal = true;
      // this.toggleBodyScroll(false);
      return;
    }

    if (val === 3) this.cleanCashier();
    if (val === 4) this.cleanBonus();

    if (val === this.selectedOption) {
      this.showGlobalMenu = !this.showGlobalMenu;
      this.toggleBodyScroll(this.showGlobalMenu); // toggle
      return;
    }

    this.selectedOption = val;
    this.showGlobalMenu = true;
    this.toggleBodyScroll(true);
  }

  closeGlobalMenu(): void {
    this.showGlobalMenu = false;
    this.toggleBodyScroll(false);
  }

  private cleanCashier(): void {
    this.eventMenuProfileService.hideNotiCashier();
  }
  private cleanBonus(): void {
    this.eventMenuProfileService.hideNotiBonus();
  }

  public noAccount(): void {
    this.showLoginModal = false;
    this.showCreateAccountModal = true;
  }

  public changeShowCreateAccountModal(val: any): void {
    this.showCreateAccountModal = val;
  }
  get isPCPlayer() {
    return this.eventMenuProfileService.isPCPlayer;
  }

  handleLoginSuccess(): void {
    this.appMain.isLoggedIn = true;
    this.showLoginModal = false;
    this.appMain.verifyLoggedIn();
    this.eventMenuProfileService.login();
  }
  closeOnBackdrop(event: MouseEvent) {
    this.showGlobalMenu = false;
  }
  private listenToCredits(): void {
  this.myCreditsMobile.showCredits$.subscribe(show => {
    if (show) {
      this.selectedOption = 2;
      this.showGlobalMenu = true;
      this.ignoreNextClick = true;
    } else {
      this.closeGlobalMenu();  
    }
  });
}
}
